import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import store from "../../store";
import { getValueByDotNotation, isFunction, isObject } from "./mcn-helpers";
import Pagination from "../../views/dashboard/models/Pagination";
import * as JsonMappedUser from '../js/models/user/User';
import User from "../../views/dashboard/models/User";
import UrlManager from "./UrlManager";
import { cloneDeep } from "lodash-es";
import snakeCase from "lodash-es/snakeCase";
import PaginationForm from "./forms/pagination/PaginationForm";
export default class VuetifyTable extends UrlManager {
  constructor(headers = [], other = {}) {
    if (!isObject(other)) other = {};
    super();
    // this name is primarily set for naming the edit columns in the store
    _defineProperty(this, "name", 'vuetifyTable');
    _defineProperty(this, "itemKey", null);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "totalItems", 1);
    _defineProperty(this, "height", '100%');
    _defineProperty(this, "heightPerRow", '100%');
    _defineProperty(this, "pagination", new Pagination());
    _defineProperty(this, "roleRequired", []);
    _defineProperty(this, "headers", []);
    _defineProperty(this, "defaultHeaders", []);
    _defineProperty(this, "checked", []);
    _defineProperty(this, "showSelect", false);
    _defineProperty(this, "singleSelect", true);
    _defineProperty(this, "textTranslationPrefix", '');
    _defineProperty(this, "sortBy", []);
    _defineProperty(this, "sortDesc", []);
    if (other.name) this.name = other.name;
    if (other.customPagination) this.pagination = other.customPagination;
    let {
      requiredRoles = [],
      itemKey = null,
      perPageItems = 5,
      textTranslationPrefix = null,
      checked = []
    } = other;
    if (textTranslationPrefix) this.textTranslationPrefix = textTranslationPrefix;
    if (Array.isArray(checked)) this.checked = checked;
    this.itemKey = itemKey;
    this.pagination.setPerPageItems(perPageItems);
    this.roleRequired = requiredRoles;
    let authenticatedUser = store.getters.authenticatedUser;
    let authenticatedUserRoleName = store.getters.authenticatedUserRoleName;
    if (!(authenticatedUser instanceof User) && !(authenticatedUser instanceof JsonMappedUser.default)) return;
    let updatedHeader = headers.map(h => {
      if (!h.hasOwnProperty('visibility')) h.visibility = true;
      if (this.textTranslationPrefix.length > 0) h.text = [this.textTranslationPrefix, h.text].join('.');
      let hasProhibitedRole = Array.isArray(h.roleProhibited) ? h.roleProhibited.includes(authenticatedUserRoleName) : h.roleProhibited === authenticatedUserRoleName;
      let hasRequiredRole = !Array.isArray(h.requiredRoles) || h.requiredRoles.includes(authenticatedUserRoleName);
      let hasPermission = !Array.isArray(h.permissions) || authenticatedUser.isPermitted(h.permissions);
      let hasCondition = !isFunction(h.condition) || h.condition();
      return !hasProhibitedRole && hasRequiredRole && hasPermission && hasCondition ? h : null;
    }).filter(h => h);
    this.defaultHeaders = cloneDeep(updatedHeader);
    this.headers = cloneDeep(updatedHeader);
    store.getters.getTableColumns(this);
  }
  get content() {
    return this.pagination.getPaginatedData();
  }
  set content(v) {
    this.pagination.setPaginatedData(v);
  }
  get currentPage() {
    let totalPages = this.getTotalPages();
    let currentPage = this.pagination instanceof PaginationForm ? this.pagination.getCurrentPage() : this.pagination.currentPage();
    return totalPages >= currentPage ? currentPage : 1;
  }
  set currentPage(v) {
    this.pagination.setCurrentPage(v);
  }
  get itemsPerPage() {
    return this.pagination.getItemsPerPage();
  }
  set itemsPerPage(itemsPerPage) {
    return this.pagination.setItemsPerPage(itemsPerPage);
  }
  resetHeaders() {
    this.headers = cloneDeep(this.defaultHeaders);
  }
  setPaginationOption(optionName, optionContent) {
    switch (optionName) {
      case 'page':
        this.pagination.setCurrentPage(optionContent);
        break;
      case 'itemsPerPage':
      case 'show':
        this.pagination.setPerPageItems(optionContent);
        break;
      case 'sortBy':
        //this.sortBy = Array.isArray(optionContent) ? optionContent.map(item => snakeCase(item)) : []
        break;
      default:
    }
  }
  setPaginationOptions(options) {
    var _options;
    options = (_options = options) !== null && _options !== void 0 ? _options : {};
    Object.keys(options).forEach(optionKey => this.setPaginationOption(optionKey, options[optionKey]));
    return this;
  }
  getCheckedItemsIds() {
    return this.getCheckedItems().map(item => getValueByDotNotation(item, this.itemKey)).filter(i => i);
  }
  getName() {
    return this.name;
  }
  getHeaders() {
    return this.headers;
  }
  getItemKey() {
    return this.itemKey;
  }
  setPagination(pagination) {
    this.pagination = pagination;
  }
  populateTable(pagination, customContent) {
    if (!(pagination instanceof Pagination) && !(pagination instanceof PaginationForm)) return this;
    this.pagination = pagination;
    this.content = isFunction(customContent) || customContent === undefined ? pagination.getPaginatedData().map(item => customContent ? customContent(item) : item).filter(i => i) : customContent;
    return this;
  }
  getHeight() {
    return this.height;
  }
  setHeight(h) {
    this.height = h;
    return this;
  }
  canShowSelect() {
    return this.showSelect;
  }
  isSingleSelect() {
    return this.singleSelect;
  }
  setHeightPerRow(h, unit = 'px') {
    var _this$content$length, _this$content;
    let contentLength = (_this$content$length = (_this$content = this.content) === null || _this$content === void 0 ? void 0 : _this$content.length) !== null && _this$content$length !== void 0 ? _this$content$length : 0;
    contentLength = contentLength > 4 ? 5 : contentLength;
    this.setHeight([h * contentLength + 48, unit].join(''));
    return this;
  }
  isPermitted() {
    var _this$roleRequired;
    return ((_this$roleRequired = this.roleRequired) === null || _this$roleRequired === void 0 ? void 0 : _this$roleRequired.length) < 1 || this.roleRequired.includes(store.getters.getAuthUserRoleName);
  }
  resetContent() {
    this.content = [];
    return this;
  }
  hasContent() {
    return this.content.length > 0;
  }
  addContentRow(row) {
    this.content.push(row);
    return this;
  }
  getItemsPerPage() {
    return this.pagination.getItemsPerPage();
  }
  getSelectedItemsPerPage() {
    return this.pagination.getSelectedItemsPerPage();
  }
  getTotalItems() {
    return this.pagination.getTotalItems();
  }
  getPaginationQuery() {
    return this.pagination.getQuery();
  }
  getQueryObject() {
    let paginationQueryObject = this.pagination.getQueryObject();
    if (this.sortBy.length) paginationQueryObject.sortBy = this.sortBy.map(item => snakeCase(item)).join();
    if (this.sortDesc.length) paginationQueryObject.sortDesc = this.sortDesc.join();
    return paginationQueryObject;
  }
  startLoading() {
    this.loading = true;
    return this;
  }
  getCheckedItems() {
    return this.checked;
  }
  resetChecked() {
    this.checked = [];
    return this;
  }
  endLoading() {
    return this.loading = false;
  }
  isLoading() {
    return this.loading;
  }
  isEmpty() {
    return !Array.isArray(this.content) || this.content.length < 1;
  }
  emptyTableContent() {
    this.content = [];
    return this;
  }
  getContent() {
    return Array.isArray(this.content) ? this.content : [];
  }
  setPaginationAttributes(optionName, value) {
    if (value) this.pagination[optionName] = value;
    return this;
  }
  getTotalPages() {
    let totalPages = this.getTotalItems() / this.getItemsPerPage();
    return Math.ceil(totalPages);
  }
  setTotalItems(totalItems) {
    this.pagination.setTotalItems(totalItems);
    return this;
  }
  updatePagination(pagination) {
    var _pagination$Paginatio, _pagination$Paginatio2;
    return this.resetContent().setTotalItems((_pagination$Paginatio = pagination === null || pagination === void 0 || (_pagination$Paginatio2 = pagination.PaginationTotal) === null || _pagination$Paginatio2 === void 0 ? void 0 : _pagination$Paginatio2.content) !== null && _pagination$Paginatio !== void 0 ? _pagination$Paginatio : 1);
  }
}